import { ADMIN_ACCESS } from './constants';

// Shared by the sidebar and route guard. devMode never grants permissions.
export const canAccessRoute = (user, pathname) => {
    if (!user) return false;
    if (user.access === ADMIN_ACCESS) return true;
    const path = pathname.toLowerCase().replace(/\/+$/, '') || '/';
    if (user.subAccount) return ['/thd', '/thd/direct'].includes(path);
    return path !== '/thd' && !path.startsWith('/thd/');
};
